import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzrnxy68kq: FaireProductEntity = {
  token: "p_zzrnxy68kq",
  type: "product",
  name: "Romantasy Lovers' Sticky Book Tabs",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/e2bd1366dfe4d18e11dfea4ee7ccfc83204c6548d43b735244a2791a8d5f51e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0957efa0a64ba9aebd823476fc0f635afe5837204eb3e16b016c5672ea3cd2a.jpeg"
  ],
  priceDollars: 5,
  description: "Book-annotating is all the rage on BookTok, and these giftable flags are just the thing for romantasy fans who want to get in on the trend! Slightly larger than typical book flags, these write-on tabs help you flag juicy bits you’d like to remember, study, celebrate, and return to, without flipping through hundreds of pages! Housed in a nifty little package, they’re both cute and practical, making the perfect gift for the book lovers in your life (including you). Sticky flags make fab gifts for book lovers (including BookTok & Bookstagram fans), stocking stuffers for readers, and thoughtful gifts for book groups. With aesthetic colors and major romantasy vibes, these colored page labels let you flag pages, take reading notes & personalize your books without marking them up! Each pad measures 4 x 3 inches and includes 5 pads with 75 sheets each, totaling 375 flags.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:41.334Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
